export default __webpack_public_path__ + "static/media/analisis2.49f814f5.png";